import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_DECLARATION_START,
} from '../../actions/types'

import {
  updateDeclarationSuccess,
  updateDeclarationFailure,
} from '../../actions'

import { putLoanApplicationUser } from '../../requesters/loanApplicationUser'

import {
  getLoanApplicationId,
   } from '../../reducers'

function* loanUpdateDeclaration({type, payload}) {
  const loanApplicationId = yield select(getLoanApplicationId);

  const data = {
    loan_application_user: {
      declaration_attributes: payload.declaration
    }
  }

  const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

  if (response) {
    yield put(updateDeclarationSuccess(response))
  } else {
    yield put(updateDeclarationFailure({
      declaration: error.response.data.declaration,
      errors: error.response.data.errors
    }))
  }
}

export function* watchLoanUpdateDeclaration() {
  yield takeLatest(UPDATE_DECLARATION_START, loanUpdateDeclaration)
}
